<template>
    <div>
      <div class="kit__utils__heading">
        <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
      </div>
      <div class="col-12 ">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6">
            <settingDeposit v-bind="sentDataSetting"></settingDeposit>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 ">
            <settingWithdraw v-bind="sentDataSetting"></settingWithdraw>
          </div>
          </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6">
            <settingWithdrawCreated v-bind="sentDataSetting"></settingWithdrawCreated>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6">
            <settingWithdrawCommission v-bind="sentDataSetting"></settingWithdrawCommission>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6">
            <settingDepositBank v-bind="sentDataSetting"></settingDepositBank>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6">
            <settingWithdrawBank v-bind="sentDataSetting"></settingWithdrawBank>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6">
            <settingSms v-bind="sentDataSetting"></settingSms>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6">
            <settingTransfer v-bind="sentDataSetting"></settingTransfer>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6">
            <settingCancel v-bind="sentDataSetting"></settingCancel>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6">
            <settingAmountTranfer v-bind="sentDataSetting"></settingAmountTranfer>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import settingDeposit from './settingDeposit'
import settingDepositBank from './settingDepositBank'
import settingWithdraw from './settingWithdraw'
import settingWithdrawBank from './settingWithdrawBank'
import settingWithdrawCommission from './settingWithdrawCommission'
import settingWithdrawCreated from './settingWithdrawCreated'
import settingSms from './settingSMS'
import settingTransfer from './settingTranferATM'
import settingCancel from './settingCancel'
import settingAmountTranfer from './settingAmountTranfer'

import apiClient from '@/services/api'
import Swal from 'sweetalert2'
export default {
  components: {
    settingDeposit,
    settingDepositBank,
    settingWithdraw,
    settingWithdrawBank,
    settingWithdrawCommission,
    settingWithdrawCreated,
    settingSms,
    settingTransfer,
    settingCancel,
    settingAmountTranfer,
  },
  data() {
    return {
      formData: [],
    }
  },
  computed: {
    sentDataSetting: function() {
      return {
        formData: this.formData,
      }
    },
  },
  methods: {
    async getSetting() {
      await apiClient.get(`/setting/${this.$route.params.id}`).then(response => {
        if (response.data.code === '000') {
          this.formData = response.data.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
              `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
  },
  async created() {
    await this.getSetting()
  },
}
</script>
<style>
</style>
